import type { BlogPostStatus } from '../types';

export const BLOG_STATUS_ORDER: BlogPostStatus[] = ['draft', 'review', 'enabled'];

export const BLOG_STATUS_LABELS: Record<BlogPostStatus, string> = {
    draft: 'Borrador',
    review: 'En revisión',
    enabled: 'Publicada',
    disabled: 'Borrador',
};

export const BLOG_STATUS_HINTS: Record<BlogPostStatus, string> = {
    draft: 'No sale en la web. El editor o la IA pueden seguir trabajando.',
    review: 'Hay contenido. Un humano revisa la vista previa antes de publicar.',
    enabled: 'Visible en la URL pública (/blog/… o /en/…). Solo marca esto tras revisar la preview. La web no cambia hasta la pipeline Aipeces-Landing-Pro (slugs nuevos dan 404 hasta entonces).',
    disabled: 'Estado legado: se trata como borrador. Al guardar pasa a Borrador.',
};

export function blogStatusLabel(status?: string | null): string {
    if (status && status in BLOG_STATUS_LABELS) {
        return BLOG_STATUS_LABELS[status as BlogPostStatus];
    }
    return status || 'Sin estado';
}

/** Lo que enseña el selector: disabled legado se edita como draft. */
export function editorStatusValue(status?: string | null): BlogPostStatus {
    if (status === 'review' || status === 'enabled' || status === 'draft') return status;
    return 'draft';
}
